import { createContext }  from 'react';

import Alert from '../utils/Alert';

export default createContext<Alert>(new Alert());
